import { Star } from "lucide-react";

/**
 * Rating de 0..5 estrelas, controlado.
 * onChange(novoValor) — clicar na mesma estrela seleciona 0.
 */
export default function StarRating({ value = 0, onChange, testid, size = "sm" }) {
  const px = size === "lg" ? "w-5 h-5" : "w-4 h-4";
  return (
    <div className="inline-flex items-center gap-0.5" data-testid={testid}>
      {[1, 2, 3, 4, 5].map((n) => {
        const filled = n <= value;
        return (
          <button
            key={n}
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onChange?.(n === value ? 0 : n);
            }}
            className={`transition ${filled ? "text-amber-500 hover:text-amber-600" : "text-slate-300 hover:text-amber-400"}`}
            title={`${n} estrela${n > 1 ? "s" : ""}`}
            data-testid={`${testid}-${n}`}
          >
            <Star className={`${px} ${filled ? "fill-amber-400" : ""}`} />
          </button>
        );
      })}
      {value > 0 && (
        <span className="ml-1 text-[10px] font-bold text-amber-600 tabular-nums">{value}/5</span>
      )}
    </div>
  );
}
